import { Helmet } from "react-helmet-async";

// Sets just the browser tab title for authenticated/internal pages — unlike SEO.js,
// this intentionally skips canonical/OG/robots tags, since these pages aren't meant
// to be indexed or shared as public content.
export default function PageTitle({ title }) {
    return (
        <Helmet>
            <title>{title}</title>
        </Helmet>
    );
}
